const heroSwiper = new Swiper('#hero-slider', {
    autoplay: true,
    grabCursor: true,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 15,
    loop: true,
    speed: 800,
    preventClicks: false,
    preventClicksPropagation: false,
    loadOnTransitionStart: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
        loadPrevNext: true,
    },
    pagination: {
        el: '.swiper-pagination.hero',
        type: 'bullets',
        bulletElement: 'div',
        bulletClass: 'swiper-pagination-bullet hero-slider',
        clickable: true,
    },
});


const collectionSwiper = new Swiper('#productHighlightsSlider', {
    autoplay: true,
    navigation: {
        nextEl: '.slider-arrow-circle.next',
        prevEl: '.slider-arrow-circle.prev',
    },
    slidesPerView: 4.4,
    centeredSlides: true,
    spaceBetween: 150,
    loop: true,
    speed: 450,
    preventClicks: false,
    preventClicksPropagation: false,
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1.6,
            centeredSlides: true,
            spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 2.6,
            centeredSlides: true,
            spaceBetween: 20,
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 3.6,
            centeredSlides: true,
            spaceBetween: 20,
        },
        993: {
            slidesPerView: 4.6,
            spaceBetween: 100
        },
    },
});


const promoSwiper = new Swiper('#promo-bar', {
    autoplay: true,
    direction: 'vertical',
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 5,
    loop: true,
    speed: 800,
});


const sampleSwiper = new Swiper("#cart-samples", {
    slidesPerView: 3.5,
    centeredSlides: false,
    spaceBetween: 20,
    loop: true,
    grabCursor: true,
    shortSwipes: false,
    preventClicks: false,
    speed: 450,
    preventClicks: true,
    preventClicksPropagation: false
});


console.log(document.querySelector('#thumbsSlider'))
let thumbsSwiper = null;

if (document.querySelector('#thumbsSlider') !== null) {
    thumbsSwiper = new Swiper('#thumbsSlider', {
        direction: 'vertical',
        spaceBetween: 10,
        freeMode: true,
        threshold: 10,
        //slideToClickedSlide: true,
        watchSlidesProgress: true,
        /*navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },*/
        mousewheel: true,
        keyboard: true,
        on: {
            beforeInit: function () {
                /* swiper 8 */
                console.log('thumbs slides', this.$el[0].dataset.slides)
                if (this.$el[0].dataset.slides <= 6) {
                    this.params.loop = false;
                    this.params.slidesPerView = this.$el[0].dataset.slides * 1;
                } else {
                    this.params.loop = true;
                    this.params.slidesPerView = 6;
                }
            },
        }
    });
    window.theme.thumbsSwiper = thumbsSwiper;
}

let options = {};
if (thumbsSwiper !== null) {
    options = {
        loop: true,
        grabCursor: true,
        threshold: 10,
        thumbs: {
            swiper: thumbsSwiper,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    }
} else {
    options = {
        loop: false,
        grabCursor: false,
        threshold: 10
    }
}
const productSwiper = new Swiper('#productSlider', options);
window.theme.productSwiper = productSwiper;
productSwiper.on('click', function () {
    let currentSlide = productSwiper.slides[productSwiper.clickedIndex];
    console.log('currentSlide', currentSlide);
    if (currentSlide.dataset.type === 'image') return;
    console.log('IS VIDEO');
    let videoSlide = currentSlide.querySelector('video');
    let videoPlay = currentSlide.querySelector('.video-play__wrapper');
    videoPlay.style = "display:none;"
    console.log('IS VIDEO', videoSlide);
    videoSlide.play();
    videoSlide.addEventListener("ended", (event) => {
        console.log("Video ended");
        setTimeout(() => {
            videoSlide.pause();
            videoSlide.currentTime = 0;
            videoSlide.load();
            videoPlay.style = "display:flex;"
        }, "500");
    });
});


